export default "__VITE_ASSET__NutbHLoK__"